import { render, staticRenderFns } from "./_iframe.vue?vue&type=template&id=07930a7c&scoped=true&"
import script from "./_iframe.vue?vue&type=script&lang=js&"
export * from "./_iframe.vue?vue&type=script&lang=js&"
import style0 from "./_iframe.vue?vue&type=style&index=0&id=07930a7c&prod&scoped=true&lang=css&"
import style1 from "./_iframe.vue?vue&type=style&index=1&id=07930a7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07930a7c",
  null
  
)

export default component.exports